(function() {
  // Normalize helpers: handle 'industry-nine-hydra-2' ⇄ model 'Industry Nine Hydra 2'
  function normalizeHandleToKey(slug) {
    return String(slug || '').replace(/-/g, '').toLowerCase();
  }
  function normalizeModelToKey(name) {
    return String(name || '').replace(/\s+/g, '').toLowerCase();
  }
  function normalizeDriverName(name){
    const s = String(name || '').toLowerCase().trim();
    const raw = s.replace(/[^a-z0-9]/g, '');
    // Canonicalize common synonyms
    if (raw === 'ms' || raw === 'microspline' || raw === 'microspl') return 'microspline';
    if (raw === 'xd' || raw === 'sramxd') return 'xd';
    if (raw === 'xdr' || raw === 'sramxdr') return 'xdr';
    if (raw === 'hg' || raw === 'shimanohg' || raw === 'shimanohyperglide') return 'hg';
    if (raw === 'xdr' || raw === 'xd road' || s.includes('xd road') || s.includes('x d road') || s.includes('sram xdr')) return 'xd road';
    if (raw === 'hgr' || raw === 'hg road' || s.includes('hg road') || s.includes('h g road') || s.includes('hyperglide road')) return 'hg road';
    if (raw === 'msr' || raw === 'ms road' || s.includes('ms road') ||  s.includes('ms road with endcap') || s.includes('microspline road') || s.includes('micro spline road')) return 'microspline road';
    return raw;
  }

  function expandDriverSynonyms(key){
    const k = String(key || '').toLowerCase();
    if (k === 'microspline') return ['microspline', 'micro-spline', 'ms'];
    return [k];
  }

  function toHandle(value){
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^[-_]+|[-_]+$/g, '');
  }

  function expandUiDriverVariants(canonical){
    const k = String(canonical || '').toLowerCase();
    if (k === 'microspline') {
      return ['MS','Microspline','Micro Spline','Micro-Spline','ms','microspline','micro spline','micro-spline'];
    }
    return [k, k.toUpperCase(), k.replace(/-/g, ' '), k.replace(/\s+/g, '-')];
  }

  function canonicalizeDriverStyle(value){
    return normalizeDriverName(value);
  }

  function normalizeAndCompareDriver(fieldVal, queryVal){
    if (!queryVal) return true;
    const canonicalQuery = canonicalizeDriverStyle(queryVal);
    const candidates = [];
    if (Array.isArray(fieldVal)) {
      for (const v of fieldVal) candidates.push(canonicalizeDriverStyle(v));
    } else if (typeof fieldVal === 'string') {
      let parsed = null;
      try { parsed = JSON.parse(fieldVal); } catch(_) {}
      if (Array.isArray(parsed)) {
        for (const v of parsed) candidates.push(canonicalizeDriverStyle(v));
      } else {
        candidates.push(canonicalizeDriverStyle(fieldVal));
      }
    } else if (fieldVal != null) {
      candidates.push(canonicalizeDriverStyle(String(fieldVal)));
    }
    // Accept synonyms like 'ms' for microspline
    const expanded = new Set();
    for (const c of candidates) {
      expanded.add(c);
      if (c === 'microspline') expanded.add('ms');
    }
    return expanded.has(canonicalQuery);
  }
  function register() {
    if (!window.Alpine) return;

    
    
    Alpine.data('hubBuilderTabs', ({ labels, model }) => {
      
      return {
      selectedId: null,
      selectedTab: null,
      labels,
      model,
      normalizedModelKey: null,
      rules: [],
      fetchingRules: false,
      ruleFetchError: null,

      init() {
        
        try {
          
          this.normalizedModelKey = normalizeHandleToKey(this.model);
          this.$nextTick(() => {
            const firstId = this.$id('tab', 1);
            this.select(firstId);
          });
          
          // Fetch rules immediately
          this.fetchRules();
          
        } catch (e) {
          console.error('[HubBuilder] Tabs.init error', e);
        }
      },

      whichChild(child, parent) {
        try {
          return Array.from(parent.children).indexOf(child) + 1;
        } catch (e) {
          return 1;
        }
      },

      isSelected(id) {
        return this.selectedId === id;
      },

      select(id) {
        this.selectedId = id;
        try {
          const idx = parseInt(String(id).split('-').pop(), 10) - 1;
          this.selectedTab = this.labels?.[idx] || null;
        } catch (e) {
          this.selectedTab = this.labels?.[0] || null;
        }
      },

      async fetchRules() {
        this.fetchingRules = true;
        this.ruleFetchError = null;
        // Mirror to globals so inner form can show loading states
        window.__HUB_RULES_FETCHING__ = true;
        window.__HUB_RULES_ERROR__ = null;
        try {
          const { rules, error } = await fetchHubRules(this.model);
          if (error) throw new Error(error);
          this.rules = rules || [];
          window.__HUB_RULES__ = this.rules;
          
        } catch (e) {
          console.error('[HubBuilder] fetchRules error', e);
          this.ruleFetchError = 'Failed to load rules';
          window.__HUB_RULES_ERROR__ = this.ruleFetchError;
        } finally {
          this.fetchingRules = false;
          window.__HUB_RULES_FETCHING__ = false;
        }
      },
    };
  });

    Alpine.data('hubBuilderForm', ({ optionKeys, tab }) => {
      
      return {
      // State
      completeOptions: (optionKeys || []).map((id, i) => ({ id, label: id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()), value: '', expanded: i === 0 })),
      // Placeholders to be wired to hub inventory/rules
      fetchingHubInventory: false,
      hubColorsLoading: false,
      hasCompletedInventoryCheck: false,
      availableHubColors: [],
      fetchingFreeHubInventory: false,
      hasCompletedFreeHubCheck: false,
      availableDrivers: [],
      availableDriversNormalized: [],
      isFetchingProducts: false,
      isAddingToCart: false,
      unavailable: false,
      loading: false,
      error: null,
      pricing: { loading: false, price: null, compareAtPrice: null },
      products: { front: null, rear: null },
      normalizedModelKey: null,
      tab: tab || 'complete',
      colorToHandleMap: {},
      driverHandleMap: {},
      // UI flags expected by shared option snippet
      showHubUnavailableMessage: false,
      showProductUnavailableMessage: false,

      init() {
        // No-op for now; inventory fetch hooks will be added next
        
        // Compute normalized key once for matching against Model fields with spaces
        this.normalizedModelKey = (window.__HUB_BUILDER_NORMALIZED_MODEL__
          || normalizeHandleToKey(window.__HUB_BUILDER_MODEL__));
        

        // Watch for option value changes to replicate accordion behavior
        this.watchOptions();
        // Initial disabling based on rules (no-op until selections made)
        this.applyRuleAvailabilityConstraints();
        
        // Watch for changes in selections and re-apply constraints
        this.$watch('completeOptions', () => {
          this.applyRuleAvailabilityConstraints();
          if (this.tab === 'driver') {
            this.updateDriverAvailability();
          }
        }, { deep: true });

        // Kick off color inventory only for hub builds (not driver-only tab)
        if (this.tab !== 'driver') {
          this.updateHubColorAvailability();
        }

        // Initialize driver availability (driver tab only)
        if (this.tab === 'driver') {
          this.updateDriverAvailability();
        }
      },

      // Helpers
      formatLabel(id) {
        return String(id || '').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
      },

      get validationHint() {
        const empty = this.completeOptions.find((o) => (o.value ?? '') === '');
        return empty ? this.formatLabel(empty.id) : '';
      },

      getOptionById(id) {
        return this.completeOptions.find((o) => o.id === id) || {};
      },

      isEveryOptionSelected() {
        return this.completeOptions.every((o) => (o.value ?? '') !== '');
      },

      isInputGroupDisabled(key) {
        const found = this.getOptionById(key);
        const idx = this.completeOptions.indexOf(found);
        if (idx <= 0) return false;
        return (this.completeOptions[idx - 1].value ?? '') === '';
      },

      clearSelections() {
        this.completeOptions = this.completeOptions.map((o, i) => ({ ...o, value: '', expanded: i === 0 }));
        this.error = null;
        this.unavailable = false;
      },

      watchOptions() {
        let oldState = this.completeOptions.map((o) => ({ id: o.id, value: o.value, expanded: o.expanded }));
        this.$watch('completeOptions', (newVal) => {
          const changed = newVal.filter((o, idx) => (o.value ?? '') !== (oldState[idx]?.value ?? ''));
          if (changed.length > 0) {
            changed.forEach((o) => this.handleValueSet(o));
          }
          oldState = newVal.map((o) => ({ id: o.id, value: o.value, expanded: o.expanded }));
        });
      },

      handleValueSet(opt) {
        // Advance accordion to next option, reset following selections if needed
        const idx = this.completeOptions.indexOf(opt);
        const nextIdx = idx + 1;
        const nextOpt = this.completeOptions[nextIdx];
        const hasAhead = this.completeOptions.slice(nextIdx).some((o) => (o.value ?? '') !== '');

        if (nextOpt) {
          if (hasAhead) {
            for (let i = nextIdx; i < this.completeOptions.length; i++) {
              const sub = this.completeOptions[i];
              sub.value = '';
              sub.expanded = i === nextIdx;
            }
          } else {
            this.$nextTick(() => { nextOpt.expanded = true; });
          }

          if ((opt.value ?? '') !== '') {
            const panel = this.$root.querySelector(`[data-option-group="${nextOpt.id}"]`);
            this.scrollToPanel(panel);
          }
        }
        // Keep current panel open to show selection
        opt.expanded = true;

        // Trigger hub color availability when structural options change
        const structural = ['hub_model','brake_type','front_spacing','rear_spacing','driver_style'];
        if (structural.includes(opt.id)) {
          if (this.tab !== 'driver') {
            this.updateHubColorAvailability();
          }
          this.applyRuleAvailabilityConstraints();
        }

        // When hub_colour is selected, fetch pricing and set product for ATC
        if (opt.id === 'hub_colour' || opt.id === 'hub_color') {
          this.updatePricingForSelectedColor();
        }

        // On driver tab, refresh available drivers if hub model changes
        if (this.tab === 'driver' && opt.id === 'hub_model') {
          this.updateDriverAvailability();
        }

        // On driver tab, update pricing when driver selection changes
        if (this.tab === 'driver' && (opt.id === 'driver_style' || opt.id === 'driver')) {
          this.updatePricingForSelectedColor();
        }
      },

      scrollToPanel(el, behavior = 'smooth') {
        if (!el) return;
        try {
          el.scrollIntoView({ behavior, block: 'center' });
        } catch (_) {}
      },

      async addToCart() {
        try {
          if (this.isAddingToCart) return; // prevent double-click
          this.isAddingToCart = true;
          if (!this.isEveryOptionSelected()) {
            this.error = 'Please select all options before adding to cart';
            this.isAddingToCart = false;
            return;
          }
          const items = [];
          const properties = Object.fromEntries(this.completeOptions.map((o) => [this.formatLabel(o.id), o.value]));

          const pushHandle = async (handle, sideLabel) => {
            const product = await fetchProductJsonByHandle(handle);
            const variant = Array.isArray(product?.variants)
              ? (product.variants.find(v => v?.available) || product.variants[0])
              : null;
            if (!variant) return false;
            const sideProps = { ...properties };
            if (sideLabel) sideProps.Side = sideLabel;
            items.push({ id: variant.id, quantity: 1, properties: sideProps });
            return true;
          };

          if (this.tab === 'driver') {
            // Add selected freehub (driver) by handle derived from freehub_inventory
            const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver').value);
            const driverKey = normalizeDriverName(selectedDriver);
            const handle = this.driverHandleMap[driverKey];
            if (!handle) { this.error = 'Selected driver is unavailable.'; return; }
            const ok = await pushHandle(handle, 'Driver');
            if (!ok) { this.error = 'No purchasable driver variant found.'; return; }
          } else if (this.tab === 'complete' || this.tab === 'front' || this.tab === 'rear') {
            const selectedColor = (this.getOptionById('hub_colour').value || this.getOptionById('hub_color').value);
            const mapping = this.colorToHandleMap[selectedColor];
            if (!mapping) {
              this.error = 'Unable to add to cart. Please select available options.';
              this.isAddingToCart = false;
              return;
            }

            if (this.tab === 'complete') {
              const okFront = mapping.front ? await pushHandle(mapping.front, 'Front') : false;
              const okRear = mapping.rear ? await pushHandle(mapping.rear, 'Rear') : false;
              if (!okFront || !okRear) {
                this.error = 'Selected color is not available for both front and rear.';
                this.isAddingToCart = false;
                return;
              }
            } else if (this.tab === 'front') {
              const okFront = mapping.front ? await pushHandle(mapping.front, 'Front') : false;
              if (!okFront) {
                this.error = 'Selected color is not available for the front hub.';
                this.isAddingToCart = false;
                return;
              }
            } else if (this.tab === 'rear') {
              const okRear = mapping.rear ? await pushHandle(mapping.rear, 'Rear') : false;
              if (!okRear) {
                this.error = 'Selected color is not available for the rear hub.';
                this.isAddingToCart = false;
                return;
              }
            }
          }

          await fetch(`${window.location.origin}/cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          });
          // Stay on page; optionally, emit an event so theme cart drawer can open
          document.dispatchEvent(new CustomEvent('cart:items-added', { detail: { count: items.length } }));
          this.isAddingToCart = false;
        } catch (e) {
          this.error = 'Failed to add to cart';
          console.error(e);
          this.isAddingToCart = false;
        }
      },

      async updateHubColorAvailability() {
        // Driver tab doesn't use color inventory
        if (this.tab === 'driver') return;
        try {
          this.hubColorsLoading = true;
          this.fetchingHubInventory = true;
          // Show theme-wide loading overlay if available
          document.documentElement.classList.add('hubbuilder-loading');
          const selected = Object.fromEntries(this.completeOptions.map((o)=>[o.id,o.value]));
          const modelHandle = window.__HUB_BUILDER_MODEL__;
          const buildType = this.tab === 'front' ? 'front' : (this.tab === 'rear' ? 'rear' : 'complete');
          
          

          // Get all colors from hub options to display (robust parsing)
          const hubColorOptions = window.__HUB_BUILDER_OPTIONS__?.hub_colour || window.__HUB_BUILDER_OPTIONS__?.hub_color;
          let allColors = [];
          if (Array.isArray(hubColorOptions)) {
            allColors = hubColorOptions.filter(Boolean);
          } else if (typeof hubColorOptions === 'string') {
            let parsed = null;
            try { parsed = JSON.parse(hubColorOptions); } catch (_) {}
            if (Array.isArray(parsed)) {
              allColors = parsed.filter(Boolean);
            } else if (hubColorOptions.includes(',')) {
              allColors = hubColorOptions.split(',').map((s) => s.trim()).filter(Boolean);
            } else if (hubColorOptions.trim().length) {
              allColors = [hubColorOptions.trim()];
            }
          }
          if (!allColors.length) {
            allColors = Object.keys(colorHandleMap);
          }
          
          
          // Fetch hub builder inventory
          const inventory = await fetchHubBuilderInventory(
            selected.hub_model || modelHandle,
            selected.brake_type,
            selected.front_spacing,
            selected.rear_spacing,
            buildType,
            '',
            '',
            allColors,
            selected.driver_style,
            selected.front_hole_count,
            selected.rear_hole_count
          );

          if (inventory.errors) {
            console.error('[HubBuilder] Inventory fetch errors:', inventory.errors);
            this.availableHubColors = [];
            this.colorToHandleMap = {};
            this.hasCompletedInventoryCheck = false;
            this.setMessageVisibility(false);
            this.hubColorsLoading = false;
            this.fetchingHubInventory = false;
            return;
          }

          // Set available colors from inventory
          this.availableHubColors = Array.isArray(inventory.availableColors) ? inventory.availableColors : [];
          // If inventory returned nothing but we have a color list, keep the list visible (disabled state handled by :disabled)
          if (!this.availableHubColors.length && Array.isArray(allColors) && allColors.length) {
            this.availableHubColors = [];
          }
          
          // Build color to handle mapping from inventory
          // { [color]: { front?: string, rear?: string, any?: string } }
          this.colorToHandleMap = {};
          if (inventory.hubInventory) {
            for (const [color, products] of Object.entries(inventory.hubInventory)) {
              let frontHandle = null;
              let rearHandle = null;
              let anyHandle = null;
              for (const p of products) {
                if (!p.available) continue;
                if (!anyHandle) anyHandle = p.handle;
                if ((p.side === 'front' || p.side === 'both') && !frontHandle) frontHandle = p.handle;
                if ((p.side === 'rear' || p.side === 'both') && !rearHandle) rearHandle = p.handle;
              }
              if (frontHandle || rearHandle || anyHandle) {
                this.colorToHandleMap[color] = { front: frontHandle || anyHandle, rear: rearHandle || anyHandle, any: anyHandle };
              }
            }
          }

          // Mark check complete first so Alpine can compute :disabled bindings
          this.hasCompletedInventoryCheck = true;
          // Wait for DOM to apply disabled states, then hide overlay
          await new Promise(r => this.$nextTick(r));
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          document.documentElement.classList.remove('hubbuilder-loading');
          this.setMessageVisibility(true);

          

        } catch (e) {
          console.error('[HubBuilder] updateHubColorAvailability error', e);
          this.availableHubColors = [];
          this.colorToHandleMap = {};
          this.hasCompletedInventoryCheck = false;
          this.setMessageVisibility(false);
          this.hubColorsLoading = false;
          this.fetchingHubInventory = false;
          document.documentElement.classList.remove('hubbuilder-loading');
        }
      },

      // Fetch available drivers for the Driver tab using freehub_inventory metaobjects
      async updateDriverAvailability() {
        if (this.tab !== 'driver') return;
        try {
          this.fetchingFreeHubInventory = true;
          this.hasCompletedFreeHubCheck = false;
          this.availableDrivers = [];
          this.availableDriversNormalized = [];
          this.driverHandleMap = {};

          const selectedModel = (this.getOptionById('hub_model').value || window.__HUB_BUILDER_MODEL__);
          const modelHandle = selectedModel;
          const entries = await fetchFreehubInventory(modelHandle);
          const availabilityChecks = [];
          const driverToHandle = {};

          for (const entry of entries) {
            const driver = entry.driver;
            const handle = entry.handle;
            if (!driver || !handle) continue;
            const key = normalizeDriverName(driver);
            driverToHandle[key] = handle; // last wins; fine for our use
            availabilityChecks.push(
              fetchProductJsonByHandle(handle)
                .then(json => {
                  const available = Array.isArray(json?.variants)
                    ? json.variants.some(v => v?.available)
                    : !!json?.available;
                  return { driver: key, available };
                })
                .catch(() => ({ driver: key, available: false }))
            );
          }

          const results = await Promise.allSettled(availabilityChecks);
          const ok = new Set();
          for (const r of results) {
            const val = r.value || r.reason;
            if (val && val.available) ok.add(val.driver);
          }

          this.availableDrivers = Array.from(ok).sort();
          const canonicalList = this.availableDrivers.map(normalizeDriverName);
          const uiKeys = new Set();
          for (const c of canonicalList) {
            // include canonical itself
            uiKeys.add(c);
            // include common UI label variants in handleized form
            for (const variant of expandUiDriverVariants(c)) {
              uiKeys.add(toHandle(variant));
            }
          }
          this.availableDriversNormalized = Array.from(uiKeys);
          // Build driver → handle map for ATC using canonical map
          for (const k of canonicalList) {
            if (driverToHandle[k]) this.driverHandleMap[k] = driverToHandle[k];
          }
          this.hasCompletedFreeHubCheck = true;
          // If a driver is selected already, refresh pricing now
          const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver').value);
          if (selectedDriver) {
            this.updatePricingForSelectedColor();
          }
        } catch (e) {
          console.error('[HubBuilder] updateDriverAvailability error', e);
          this.availableDrivers = [];
          this.availableDriversNormalized = [];
          this.driverHandleMap = {};
          this.hasCompletedFreeHubCheck = true;
        } finally {
          this.fetchingFreeHubInventory = false;
        }
      },

      async updatePricingForSelectedColor() {
        try {
          this.pricing.loading = true;
          if (this.tab === 'driver') {
            const selectedDriver = (this.getOptionById('driver_style').value || this.getOptionById('driver').value);
            const driverKey = normalizeDriverName(selectedDriver);
            const handle = this.driverHandleMap[driverKey];
            if (!handle) { this.pricing.loading = false; this.pricing.price = null; this.pricing.compareAtPrice = null; return; }
            const pricing = await fetchProductPricingByHandle(handle);
            this.pricing.price = pricing.price ? formatMoneyV2(pricing.price) : null;
            this.pricing.compareAtPrice = pricing.compareAtPrice ? formatMoneyV2(pricing.compareAtPrice) : null;
          } else {
            const color = (this.getOptionById('hub_colour').value || this.getOptionById('hub_color').value);
            const mapping = this.colorToHandleMap[color];
            if (!mapping) { this.pricing.loading = false; return; }
            if (this.tab === 'complete') {
              const handles = [mapping.front, mapping.rear].filter(Boolean);
              const results = await Promise.all(handles.map(h => fetchProductPricingByHandle(h)));
              let sum = 0; let sumCompare = 0; let currency = null;
              results.forEach(r => {
                if (r.price) { sum += parseFloat(r.price.amount || 0); currency = r.price.currencyCode || currency; }
                if (r.compareAtPrice) { sumCompare += parseFloat(r.compareAtPrice.amount || 0); }
              });
              const priceObj = currency ? { amount: String(sum), currencyCode: currency } : null;
              const compareObj = currency && sumCompare > 0 ? { amount: String(sumCompare), currencyCode: currency } : null;
              this.pricing.price = priceObj ? formatMoneyV2(priceObj) : null;
              this.pricing.compareAtPrice = compareObj ? formatMoneyV2(compareObj) : null;
            } else {
              const handle = (this.tab === 'rear') ? (mapping.rear || mapping.any) : (mapping.front || mapping.any);
              if (!handle) { this.pricing.loading = false; return; }
              const pricing = await fetchProductPricingByHandle(handle);
              this.pricing.price = pricing.price ? formatMoneyV2(pricing.price) : null;
              this.pricing.compareAtPrice = pricing.compareAtPrice ? formatMoneyV2(pricing.compareAtPrice) : null;
            }
          }
          this.pricing.loading = false;
        } catch (e) {
          this.pricing.loading = false;
        }
      },

      // Disable option values based on hub rules
      async applyRuleAvailabilityConstraints() {
        try {
          const modelHandle = window.__HUB_BUILDER_MODEL__;
          const rules = await ensureHubRules(modelHandle);
          
          
          const selected = Object.fromEntries(this.completeOptions.map((o)=>[o.id,o.value]));
          
          
          const buildType = this.tab === 'front' ? 'front' : (this.tab === 'rear' ? 'rear' : 'complete');
          
          // Filter rules that match current selections so far
          const relevant = (rules||[]).filter((r)=>{
            const f = Object.fromEntries(r.fields.map((x)=>[x.key,x.value]));
            
            // Check if any selected options conflict with this rule
            for (const [key, value] of Object.entries(selected)) {
              if (!value || !f[key]) continue;
              if (key === 'driver_style' || key === 'driver') {
                if (!normalizeAndCompareDriver(f[key], value)) return false;
              } else {
                if (f[key] !== value) return false;
              }
            }
            return true; // This rule is compatible with current selections
          });
          
          
          
          // For each option that's not yet selected, determine available values
          this.completeOptions.forEach(option => {
            // Skip hub model and hub colours here – they are not rule-hidden at this level
            if (option.id === 'hub_model' || option.id === 'hub_colour' || option.id === 'hub_color') {
              return;
            }
            if (!selected[option.id]) {
              const availableValues = new Set();
              const isDriverField = (option.id === 'driver_style' || option.id === 'driver');
              
              relevant.forEach(rule => {
                const fields = Object.fromEntries(rule.fields.map(x => [x.key, x.value]));
                if (fields[option.id]) {
                  if (isDriverField) {
                    availableValues.add(normalizeDriverName(fields[option.id]));
                  } else {
                    availableValues.add(fields[option.id]);
                  }
                }
              });
              
              
              
              // Apply constraints to the option in the UI
              const optionContainer = this.$root.querySelector(`[data-option-group="${option.id}"]`);
              
              if (optionContainer) {
                // Find all value elements within this option (both inputs and containers)
                const valueElements = optionContainer.querySelectorAll('[data-value]');
                valueElements.forEach(el => {
                  const value = el.getAttribute('data-value');
                  const isContainer = !el.tagName || el.tagName !== 'INPUT';
                  const allow = isDriverField
                    ? availableValues.has(normalizeDriverName(value))
                    : availableValues.has(value);
                  
                  if (allow) {
                    // Enable this option
                    el.style.display = '';
                    el.classList.remove('disabled', 'unavailable');
                    if (!isContainer) {
                      el.removeAttribute('disabled');
                    }
                  } else {
                    // Disable/hide this option
                    el.style.display = 'none';
                    el.classList.add('disabled', 'unavailable');
                    if (!isContainer) {
                      el.setAttribute('disabled', 'true');
                    }
                  }
                });
              }
            }
          });
        } catch (e) {
          console.error('[HubBuilder] applyRuleAvailabilityConstraints error:', e);
        }
      },

      // UI helpers (no-ops for now, used by snippet conditions)
      setMessageVisibility(hasInventory) {
        this.showHubUnavailableMessage = hasInventory === true && (!this.availableHubColors || this.availableHubColors.length === 0);
        this.showProductUnavailableMessage = this.unavailable === true;
      },
      updateHubColorUI() { /* no-op for hub builder */ },
    };
  });
  }

  // --- Helpers used across components ---
  const STOREFRONT_API_VERSION = '2025-07';
  const STOREFRONT_TOKEN = 'a315a9b6f534f4b2ed483eb279323c75';

  async function storefrontGraphQL(query, variables) {
    const endpoint = `https://${window.location.hostname}/api/${STOREFRONT_API_VERSION}/graphql.json`;
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query, variables }),
    });
    const data = await res.json();
    return data;
  }

  function getCountryCodeForContext() {
    // Prefer section-provided country (Markets), then Shopify country, then HTML lang-country, then US
    const explicit = window.__HUB_BUILDER_COUNTRY__;
    if (explicit && typeof explicit === 'string') return explicit.toUpperCase();
    const shopifyCountry = window.Shopify && window.Shopify.country;
    if (shopifyCountry && typeof shopifyCountry === 'string') return shopifyCountry.toUpperCase();
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toUpperCase();
    // Try to extract trailing country code from patterns like en-US
    const match = htmlLang.match(/-[A-Z]{2}$/);
    if (match) return match[0].slice(1);
    return 'US';
  }

  function formatMoneyV2(money) {
    if (!money || typeof money.amount === 'undefined') return '';
    const amount = parseFloat(money.amount);
    if (!isFinite(amount)) return '';
    const code = money.currencyCode || window.__HUB_BUILDER_CURRENCY__ || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(amount);
    } catch (_) {
      return `${code} ${amount.toFixed(2)}`;
    }
  }

  async function fetchProductPricingByHandle(handle) {
    const country = getCountryCodeForContext();
    const query = `
      query ProductByHandle($handle: String!, $country: CountryCode!) @inContext(country: $country) {
        product(handle: $handle) {
          variants(first: 10) {
            edges {
              node {
                availableForSale
                priceV2 { amount currencyCode }
                compareAtPriceV2 { amount currencyCode }
              }
            }
          }
        }
      }
    `;
    const { data, errors } = await storefrontGraphQL(query, { handle, country });
    if (errors) throw new Error('Pricing query failed');
    const edges = data && data.product && data.product.variants && data.product.variants.edges || [];
    // Prefer an available variant; fallback to first
    const availableEdge = edges.find(e => e && e.node && e.node.availableForSale) || edges[0];
    const node = availableEdge && availableEdge.node;
    // If we have a valid non-zero price from Storefront, use it
    if (node && node.priceV2 && parseFloat(node.priceV2.amount) > 0) {
      return { price: node.priceV2, compareAtPrice: node.compareAtPriceV2 };
    }
    // Fallback: use product JSON (store default currency) if Storefront returned 0/empty
    try {
      const json = await fetchProductJsonByHandle(handle);
      const variant = Array.isArray(json?.variants) ? (json.variants.find(v => v?.available) || json.variants[0]) : null;
      if (variant && typeof variant.price === 'number') {
        const code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
        return {
          price: { amount: String(variant.price / 100), currencyCode: code },
          compareAtPrice: variant.compare_at_price ? { amount: String(variant.compare_at_price / 100), currencyCode: code } : null,
        };
      }
    } catch (_) {}
    return { price: null, compareAtPrice: null };
  }

  async function fetchHubRules(modelHandle) {
    try {
      
      let results = [];
      let cursor = null;
      let hasMore = true;
      while (hasMore) {
        
        const response = await storefrontGraphQL(
          `query GetHubRules($type: String!, $entryCount: Int!, $cursor: String){
            metaobjects(type: $type, first: $entryCount, after: $cursor){
              edges{ node{ handle type fields{ key value } } }
              pageInfo{ hasNextPage endCursor }
            }
          }`,
          { type: 'hub_rule', entryCount: 250, cursor }
        );
        
        const { data, errors } = response;
        if (errors) {
          console.error('[HubBuilder] GraphQL errors:', errors);
          return { rules: [], error: `GraphQL errors: ${JSON.stringify(errors)}` };
        }
        const edges = data?.metaobjects?.edges || [];
        
        results = results.concat(edges.map((e)=>e.node));
        hasMore = data?.metaobjects?.pageInfo?.hasNextPage;
        cursor = data?.metaobjects?.pageInfo?.endCursor;
      }
      // Filter by hub model with robust normalization

      const normalizeKey = (s) => {
        return String(s || '')
          .toLowerCase()
          .replace(/\b(front-hub|rear-hub|hubset|hubs|hub)\b/g, '')
          .replace(/[-_\s/]+/g, '')
          .trim();
      };

      const modelKey = normalizeKey(modelHandle);
      

      const filtered = results.filter((node) => {
        const map = Object.fromEntries((node.fields || []).map((f) => [f.key, f.value]));
        const hubModel = map.hub_model_handle || map.hub_model || '';
        const nodeKey = normalizeKey(hubModel);

        // Match if keys are equal, or one contains the other (e.g., solix vs solixmountain)
        const equal = nodeKey === modelKey;
        const contains = nodeKey.includes(modelKey) || modelKey.includes(nodeKey);
        const finalMatch = equal || contains;

        
        return finalMatch;
      });
      
      return { rules: filtered };
    } catch (e) {
      console.error('[HubBuilder] fetchHubRules exception:', e);
      return { rules: [], error: e?.message || 'Failed to fetch rules' };
    }
  }

  async function ensureHubRules(modelHandle){
    if (Array.isArray(window.__HUB_RULES__)) return window.__HUB_RULES__;
    const { rules } = await fetchHubRules(modelHandle);
    window.__HUB_RULES__ = rules || [];
    return window.__HUB_RULES__;
  }

  // Fetch hub builder inventory information from metaobjects
  async function fetchHubBuilderInventory(
    hubModel,
    brakeType,
    frontSpacing,
    rearSpacing,
    buildType = "complete",
    frontRim = "",
    rearRim = "",
    allowedColors = [],
    driverStyle = "",
    frontHoleCount = "",
    rearHoleCount = ""
  ) {
    let results = [];
    let hasMore = true;
    let cursor = null;

    

    // Format query parameters for consistency
    const queryParams = {
      hubModel: hubModel?.toLowerCase().trim() || "",
      brakeType: brakeType?.toLowerCase().trim() || "",
      frontSpacing: frontSpacing?.toLowerCase().trim() || "",
      rearSpacing: rearSpacing?.toLowerCase().trim() || "",
      buildType: buildType?.toLowerCase().trim() || "complete",
      frontRim: frontRim?.toLowerCase().trim() || "",
      rearRim: rearRim?.toLowerCase().trim() || "",
      driverStyle: normalizeDriverName(driverStyle) || "",
      frontHoleCount: frontHoleCount?.toLowerCase().trim() || "",
      rearHoleCount: rearHoleCount?.toLowerCase().trim() || "",
    };

    // Track all unique colors and their availability
    const colorInventory = {};
    const allColors = [];
    const availableColors = [];
    const baseHandles = [];

    // Fetch hub builder inventory metaobjects
    while (hasMore) {
      const response = await storefrontGraphQL(
        `query GetHubBuilderInventory($type: String!, $entryCount: Int!, $cursor: String) {
          metaobjects(type: $type, first: $entryCount, after: $cursor) {
            edges {
              node {
                handle
                type
                fields {
                  key
                  value
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }`,
        {
          type: "hub_builder_inventory",
          entryCount: 250,
          cursor,
        }
      );

      const { data, errors } = response;
      if (errors) {
        console.error('[HubBuilder] Hub builder inventory fetch errors:', errors);
        return {
          errors,
        };
      }

      const { metaobjects } = data ?? {};
      const { edges, pageInfo } = metaobjects ?? {};
      if (edges) {
        
        results = results.concat(edges.map((edge) => edge.node));
      }
      hasMore = pageInfo?.hasNextPage;
      cursor = pageInfo?.endCursor;
    }

    

    // Helper function to normalize and compare strings (treat hyphens and spaces equally)
    function normalizeAndCompare(str1, str2) {
      if (!str1 || !str2) return false;

      // Handle JSON array strings in metaobject fields (format: ["value"])
      let normalizedStr1 = str1;
      try {
        if (typeof str1 === 'string' && str1.trim().startsWith("[") && str1.trim().endsWith("]")) {
          const parsed = JSON.parse(str1);
          if (Array.isArray(parsed) && parsed.length > 0) {
            normalizedStr1 = parsed[0];
          }
        }
      } catch (_) {}

      const canonical = (s) => String(s)
        .toLowerCase()
        .trim()
        .replace(/[-_–—]/g, ' ')
        .replace(/\s+/g, ' ');

      return canonical(normalizedStr1) === canonical(str2);
    }

    function normalizeAndCompareDriverLocal(fieldVal, queryVal){
      if (!queryVal) return true;
      const canonicalQuery = normalizeDriverName(queryVal);
      const candidates = [];
      if (Array.isArray(fieldVal)) {
        for (const v of fieldVal) candidates.push(normalizeDriverName(v));
      } else if (typeof fieldVal === 'string') {
        let parsed = null;
        try { parsed = JSON.parse(fieldVal); } catch(_) {}
        if (Array.isArray(parsed)) {
          for (const v of parsed) candidates.push(normalizeDriverName(v));
        } else {
          candidates.push(normalizeDriverName(fieldVal));
        }
      } else if (fieldVal != null) {
        candidates.push(normalizeDriverName(String(fieldVal)));
      }
      const expanded = new Set(candidates);
      if (expanded.has('microspline')) expanded.add('ms');
      return expanded.has(canonicalQuery);
    }

    // Filter hub builder inventory metaobjects based on selected options
    const relevantInventory = results.filter((metaobj) => {
      const fields = metaobj.fields.reduce((acc, field) => {
        acc[field.key] = field.value;
        return acc;
      }, {});

      // Check if this inventory record matches our selected options
      const hubModelMatch = normalizeAndCompare(fields.hub_model_handle || fields.hub_model, queryParams.hubModel);
      const brakeTypeMatch = !queryParams.brakeType || normalizeAndCompare(fields.brake_type, queryParams.brakeType);
      const frontSpacingMatch = !queryParams.frontSpacing || normalizeAndCompare(fields.front_spacing, queryParams.frontSpacing);
      const rearSpacingMatch = !queryParams.rearSpacing || normalizeAndCompare(fields.rear_spacing, queryParams.rearSpacing);
      const driverStyleMatch = !queryParams.driverStyle || normalizeAndCompareDriverLocal(fields.driver_style, queryParams.driverStyle);
      const frontHoleMatch = !queryParams.frontHoleCount || normalizeAndCompare(fields.front_hole_count, queryParams.frontHoleCount);
      const rearHoleMatch = !queryParams.rearHoleCount || normalizeAndCompare(fields.rear_hole_count, queryParams.rearHoleCount);

      return hubModelMatch && brakeTypeMatch && frontSpacingMatch && rearSpacingMatch && driverStyleMatch && frontHoleMatch && rearHoleMatch;
    });

    

    // Process each relevant inventory record
    for (const metaobj of relevantInventory) {
      const fields = metaobj.fields.reduce((acc, field) => {
        acc[field.key] = field.value;
        return acc;
      }, {});

      // Colors: support JSON array, comma-separated string, or single value
      let colors = [];
      const rawColors = fields.colors || fields.hub_colours || fields.hub_colors;
      if (Array.isArray(rawColors)) {
        colors = rawColors;
      } else if (typeof rawColors === 'string') {
        let parsed = null;
        try { parsed = JSON.parse(rawColors); } catch (_) {}
        if (Array.isArray(parsed)) {
          colors = parsed;
        } else if (rawColors.includes(',')) {
          colors = rawColors.split(',').map((s) => s.trim()).filter(Boolean);
        } else if (rawColors.trim().length) {
          colors = [rawColors.trim()];
        }
      }
      // Fallback to allowedColors from hub_options if inventory record doesn't carry colors
      if (!colors.length && Array.isArray(allowedColors) && allowedColors.length) {
        colors = allowedColors;
      }

      // Determine base handles for this record depending on build type
      const recordBaseHandles = [];
      const base = fields.base_handle || fields.base || '';
      const frontBase = fields.front_handle || fields.front_product_handle || '';
      const rearBase = fields.rear_handle || fields.rear_product_handle || '';

      if (buildType === 'front') {
        if (frontBase) recordBaseHandles.push({ handle: frontBase, side: 'front' });
        else if (base) recordBaseHandles.push({ handle: base, side: 'both' });
      } else if (buildType === 'rear') {
        if (rearBase) recordBaseHandles.push({ handle: rearBase, side: 'rear' });
        else if (base) recordBaseHandles.push({ handle: base, side: 'both' });
      } else {
        if (frontBase) recordBaseHandles.push({ handle: frontBase, side: 'front' });
        if (rearBase) recordBaseHandles.push({ handle: rearBase, side: 'rear' });
        if (!frontBase && !rearBase && base) recordBaseHandles.push({ handle: base, side: 'both' });
      }

      for (const bh of recordBaseHandles) {
        if (bh?.handle && !baseHandles.includes(bh.handle)) baseHandles.push(bh.handle);
      }

      // Process each color against all base handles for this record
      for (const color of colors) {
        if (!allColors.includes(color)) {
          allColors.push(color);
        }
        if (!colorInventory[color]) {
          colorInventory[color] = [];
        }
        for (const bh of recordBaseHandles) {
          if (!bh?.handle) continue;
          const suffix = (colorHandleMap[color]) || String(color).toLowerCase().replace(/\s+/g, '-');
          const colorHandle = `${bh.handle}-${suffix}`;
          colorInventory[color].push({
            handle: colorHandle,
            baseHandle: bh.handle,
            side: bh.side || 'both',
            available: false,
          });
        }
      }
    }

    // Fallback to hub rules if no base handles were derived from inventory
    if (!baseHandles.length) {
      try {
        const { rules } = await fetchHubRules(hubModel);
        const relevantRules = (rules || []).filter((r) => {
          const f = Object.fromEntries(r.fields.map((x) => [x.key, x.value]));
          if (!normalizeAndCompare(f.hub_model_handle || f.hub_model, queryParams.hubModel)) return false;
          if (queryParams.brakeType && f.brake_type && !normalizeAndCompare(f.brake_type, queryParams.brakeType)) return false;
          if (queryParams.frontSpacing && f.front_spacing && !normalizeAndCompare(f.front_spacing, queryParams.frontSpacing)) return false;
          if (queryParams.rearSpacing && f.rear_spacing && !normalizeAndCompare(f.rear_spacing, queryParams.rearSpacing)) return false;
          if (queryParams.driverStyle && f.driver_style && !normalizeAndCompareDriverLocal(f.driver_style, queryParams.driverStyle)) return false;
          if (queryParams.frontHoleCount && f.front_hole_count && !normalizeAndCompare(f.front_hole_count, queryParams.frontHoleCount)) return false;
          if (queryParams.rearHoleCount && f.rear_hole_count && !normalizeAndCompare(f.rear_hole_count, queryParams.rearHoleCount)) return false;
          return true;
        });
        relevantRules.forEach((r) => {
          const f = Object.fromEntries(r.fields.map((x) => [x.key, x.value]));
          if (buildType === 'front' || buildType === 'complete') {
            const fh = f.front_handle || f.front_product_handle;
            if (fh && !baseHandles.includes(fh)) baseHandles.push(fh);
            if (fh) {
              for (const color of allowedColors || []) {
                const suffix = (colorHandleMap[color]) || String(color).toLowerCase().replace(/\s+/g, '-');
                const colorHandle = `${fh}-${suffix}`;
                if (!colorInventory[color]) colorInventory[color] = [];
                colorInventory[color].push({ handle: colorHandle, baseHandle: fh, side: 'front', available: false });
              }
            }
          }
          if (buildType === 'rear' || buildType === 'complete') {
            const rh = f.rear_handle || f.rear_product_handle;
            if (rh && !baseHandles.includes(rh)) baseHandles.push(rh);
            if (rh) {
              for (const color of allowedColors || []) {
                const suffix = (colorHandleMap[color]) || String(color).toLowerCase().replace(/\s+/g, '-');
                const colorHandle = `${rh}-${suffix}`;
                if (!colorInventory[color]) colorInventory[color] = [];
                colorInventory[color].push({ handle: colorHandle, baseHandle: rh, side: 'rear', available: false });
              }
            }
          }
        });
      } catch (_) {}
    }

    // Check product availability for each color
    const availabilityPromises = [];
    for (const [color, products] of Object.entries(colorInventory)) {
      for (const product of products) {
        availabilityPromises.push(
          fetchProductJsonByHandle(product.handle)
            .then(data => {
              const hasAvailableVariant = Array.isArray(data?.variants)
                ? data.variants.some(v => v?.available === true)
                : !!data?.available;
              product.available = !!hasAvailableVariant;
              
            })
            .catch(error => {
              console.error(`[HubBuilder] Error checking availability for ${product.handle}:`, error);
              product.available = false;
            })
        );
      }
    }

    // Wait for all availability checks to complete
    await Promise.allSettled(availabilityPromises);

    // Determine which colors are available based on build type
    for (const color of allColors) {
      const colorProducts = colorInventory[color] || [];
      let isColorAvailable = false;

      if (queryParams.buildType === "front") {
        isColorAvailable = colorProducts.some((item) => item.available && (item.side === 'front' || item.side === 'both'));
      } else if (queryParams.buildType === "rear") {
        isColorAvailable = colorProducts.some((item) => item.available && (item.side === 'rear' || item.side === 'both'));
      } else {
        // For complete builds: require at least one available FRONT and one available REAR (they may come from different entries)
        const hasFront = colorProducts.some((item) => item.available && (item.side === 'front' || item.side === 'both'));
        const hasRear = colorProducts.some((item) => item.available && (item.side === 'rear' || item.side === 'both'));
        isColorAvailable = hasFront && hasRear;
      }

      if (isColorAvailable && !availableColors.includes(color)) {
        availableColors.push(color);
      }
    }

    // Sort the available colors
    availableColors.sort();

    

    return {
      hubInventory: colorInventory,
      availableColors: availableColors,
      allColors: allColors,
      baseHandles: baseHandles,
    };
  }

  const colorHandleMap = {
    Black: 'black', Silver: 'silver', Gold: 'gold', Orange: 'orange', Purple: 'purple', Green: 'green', Red: 'red', Bronze: 'bronze', Turquoise: 'turquoise', Blue: 'blue', Maple: 'maple', Pink: 'pink', Flatearth: 'flatearth'
  };

  async function fetchProductJsonByHandle(handle){
    const url = `${window.location.origin}/products/${encodeURIComponent(handle)}.js`;
    const res = await fetch(url);
    if (!res.ok) throw new Error('not found');
    return await res.json();
  }

  // Fetch Freehub Inventory metaobjects and map to entries relevant to a hub model
  async function fetchFreehubInventory(modelHandle){
    let results = [];
    let cursor = null;
    let hasMore = true;

    const normalize = (s) => String(s || '')
      .toLowerCase()
      .replace(/\b(front-hub|rear-hub|hubset|hubs|hub)\b/g, '')
      .replace(/[-_\s/]+/g, '')
      .trim();
    const modelKey = normalize(modelHandle);

    while (hasMore) {
      const response = await storefrontGraphQL(
        `query GetFreehubInventory($type: String!, $count: Int!, $cursor: String){
          metaobjects(type: $type, first: $count, after: $cursor){
            edges{ node{ handle fields{ key value } } }
            pageInfo{ hasNextPage endCursor }
          }
        }`,
        { type: 'freehub_inventory', count: 250, cursor }
      );
      const { data, errors } = response || {};
      if (errors) break;
      const edges = data?.metaobjects?.edges || [];
      results = results.concat(edges.map(e => e.node));
      hasMore = data?.metaobjects?.pageInfo?.hasNextPage;
      cursor = data?.metaobjects?.pageInfo?.endCursor;
    }

    // Map only entries matching the current hub model
    const entries = [];
    for (const node of results) {
      const map = Object.fromEntries((node.fields || []).map(f => [f.key, f.value]));
      const nodeKey = normalize(map.hub_model_handle || map.hub_model);
      if (!nodeKey) continue;
      if (nodeKey === modelKey || nodeKey.includes(modelKey) || modelKey.includes(nodeKey)) {
        entries.push({
          hubModel: map.hub_model || map.hub_model_handle,
          driver: map.driver || map.freehub || map.freehub_driver,
          handle: map.freehub_handle || map.handle || map.product_handle,
        });
      }
    }
    return entries;
  }

  console.log('[HubBuilder] Checking for Alpine...', !!window.Alpine);
  
  if (window.Alpine) {
    console.log('[HubBuilder] Alpine found, registering immediately');
    register();
  } else {
    console.log('[HubBuilder] Alpine not found, waiting for alpine:init event');
    document.addEventListener('alpine:init', () => {
      console.log('[HubBuilder] alpine:init event fired, registering components');
      register();
    });
  }
})();


